var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div>\n<loader ng-show=\"src == null\"/>\n<img ng-src=\"{{src}}\"/>\n</div>";
var id1="deskewed.image.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/deskewed-image/deskewed.image.html
// module id = 525
// module chunks = 0